import React, { useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { useLocation, useParams } from 'react-router-dom'
import axios from "axios";
import ReactLoading from 'react-loading';
import config from "../../config";
import Barcode from 'react-barcode';
const ManifestPage = () => {
    const shipment_id = useParams()
     let userDetail = localStorage.getItem('ship_rocket_user');
      let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
  
    const [state, setState] = React.useState({ shipment_list: [],  company_info: "" })
    const [isloading, setisloading] = React.useState(true)
    useEffect(() => {
    // Generate barcode
    document.querySelectorAll('.barcode-svg').forEach(svg => {
      svg.innerHTML = '';
      JsBarcode(svg, svg.getAttribute('data-value'), {
        format: 'CODE128',
        lineColor: '#000',
        width: 1.5,
        height: 40,
        displayValue: true,
      });
    });
   

    // Set manifest info
    const now = new Date();
    const manifestId = generateManifestId(now);
    const manifestDate = formatCurrentDate(now);

    document.querySelector('#manifest-id').textContent = manifestId;
    document.querySelector('#manifest-date').textContent = manifestDate;
  }, []);
  React.useEffect(()=>{
    shipment_list()
},[])

  const generateManifestId = (now) => {
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const year = now.getFullYear();
    return `${day}${month}${hours}${minutes}${year}`;
  };

  const formatCurrentDate = (now) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = String(now.getDate()).padStart(2, '0');
    const month = months[now.getMonth()];
    const year = now.getFullYear();
    return `${month} ${day},${year}`;
  };


  const shipment_list = () => {
    let dataToSend = {
      customer_id: userData.customer_id, shipment_id: shipment_id.shipment_id
    };
    let url = config.apiUrl + '/shipment/manifest_shipments';
 axios.post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // // console.log("responseJson => ", res);
        setState({ shipment_list: res.data.output, company_info: res.data.company_name })
       setisloading(false)
       })
      .catch((error) => {
        });

  }

  return (
    <div className="container-fluid mb-1">
      <div className="mb-1 no-print text-end p-2 bg-dark">
        <button className="btn btn-light" onClick={() => window.print()}>
          Print Manifest
        </button>
      </div>

      <div className="manifest-header text-center">
        <h1>Order Manifest</h1>
        <div className="row">
          <div className="col">
            <strong>{state.company_info}</strong>
          </div>
          <div className="col">
            (Manifest Id : <strong id="manifest-id">-</strong>)
          </div>
          <div className="col">
            Manifest Date : <strong id="manifest-date">-</strong>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th className='m_table' style={{ width: '10px' }}>#</th>
              <th className='m_table' style={{ width: '400px' }}>Customer Info</th>
              <th className='m_table' style={{ width: '200px' }}>Product Name & SKU (Qty)</th>
              <th className='m_table' style={{ width: '80px' }}>T. Qty</th>
              <th className='m_table' style={{ width: '80px' }}>Product Amount</th>
              <th className='m_table' style={{ width: '100px' }}>Shipping Amount</th>
              <th className='m_table' style={{ width: '100px' }}>Order Info</th>
              <th className='m_table' style={{ width: '300px' }}>AWB Barcode</th>
            </tr>
          </thead>
          {state.shipment_list.length > 0 ? (
  state.shipment_list.map((item, index) => {
    const productDetails = item.items
      ?.map(
        (prod) =>
          `${prod.item_name || "-"} (${prod.item_sku || "-"})`
      )
      .join(", ");

    const totalQuantity = item.items?.reduce(
      (sum, prod) => sum + (parseInt(prod.item_quantity) || 0),
      0
    );

    return (
      <tbody key={index}>
        <tr>
          <td>{index + 1}</td>
          <td>
            {item.receiver[0].name}<br />
            {item.receiver[0].address}, {item.receiver[0].city}, {item.receiver[0].state}, {item.receiver[0].pincode}<br />
            M: {item.receiver[0].mobile}<br />
            Email: {item.receiver[0].email}
          </td>
          <td>{productDetails}</td>
          <td>{totalQuantity}</td>
          <td>Rs {item.items.reduce((total, sub) => total + parseFloat(sub.item_value), 0).toFixed(2)}</td>
          <td>Rs {item.total_amount}</td>
          <td>
            {item.order_number}<br />
            {item.shipment_created_date}
          </td>
          <td className="barcode_td text-center">
            <Barcode value={item.carrier_tracking_number} height={60} width={3}  />
          </td>
        </tr>
      </tbody>
    );
  })
) : (
  ""
)}
        </table>
      </div>

      <div className="row signature-section">
        <div className="col-md-6">
          <p><strong>Merchant Signature:</strong></p>
          <p className="mt-5">_________________________</p>
          <p><strong>Merchant SPOC Name:</strong></p>
        </div>
        <div className="col-md-6">
          <p><strong>Courier Signature:</strong></p>
          <p className="mt-5">_________________________</p>
          <p><strong>Courier SPOC Name:</strong></p>
        </div>
      </div>
    </div>
  );
};

export default ManifestPage;
